<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-new_order-description') }}
        </p>

        <div class="field">
            <label
                :class="{
                    label: true,
                    'label-danger': !isFieldValid('filterType'),
                }"
                >{{ t('automations-form-triggers_config-new_order-when_label') }}
            </label>
            <select v-model="filterType" class="form-control">
                <option value="all">{{ t('automations-form-triggers_config-new_order-when_options-all') }}</option>
                <option value="every">{{ t('automations-form-triggers_config-new_order-when_options-every') }}</option>
                <option value="greater">{{ t('automations-form-triggers_config-new_order-when_options-greater') }}</option>
                <option value="lower">{{ t('automations-form-triggers_config-new_order-when_options-lower') }}</option>
                <option value="exact">{{ t('automations-form-triggers_config-new_order-when_options-exact') }}</option>
            </select>
        </div>

        <div class="field" v-if="filterType !== 'all'">
            <label
                :class="{
                    label: true,
                    'label-danger': !isFieldValid('filter'),
                }"
                >{{ t('automations-form-triggers_config-new_order-x_label') }}
            </label>
            <small v-if="filterType === 'every'">
                {{ t('automations-form-triggers_config-new_order-every_help') }}
            </small>
            <small v-if="filterType === 'exact'">
                {{ t('automations-form-triggers_config-new_order-exact_help') }}
            </small>
            <input type="tel" v-model="filter" class="form-control" />
        </div>

        <div class="field filter-value">
            <label
                :class="{
                    label: true,
                    'label-danger': !isFieldValid('filterValue'),
                }"
                ><input type="checkbox" v-model="filterValue" /> {{ t('automations-form-triggers_config-new_order-filter_value_label') }}</label
            >
            <div class="row inputs" v-if="filterValue">
                <div class="col-6">
                    <span
                        :class="{
                            label: true,
                            'label-danger': !isFieldValid('minValue'),
                        }"
                        >{{ t('automations-form-triggers_config-new_order-min_value_label') }}</span
                    >
                    <input
                        type="tel"
                        v-model.lazy="minValue"
                        v-money="$store.state.money"
                        class="form-control"
                    />
                </div>
                <div class="col-6">
                    <span
                        :class="{
                            label: true,
                            'label-danger': !isFieldValid('maxValue'),
                        }"
                        >{{ t('automations-form-triggers_config-new_order-max_value_label') }}</span
                    >
                    <input
                        type="tel"
                        v-model.lazy="maxValue"
                        v-money="$store.state.money"
                        class="form-control"
                    />
                </div>
            </div>
        </div>
        <div
            class="field filter-value"
            v-for="field in fieldsThatCanFilter"
            :key="field.id"
        >
        <template v-if="customFieldsFilter[field.id] !== undefined">
            <label :class="{ label: true }">
                <input
                type="checkbox"
                v-model="customFieldsFilter[field.id]['enabled']"
                />
                {{ t('automations-form-triggers_config-new_order-filter_field_label', [field.field_name]) }}

                <span v-if="field.type == 'checkbox'" class="tooltip-inline min">
                    ?
                    <span class="tooltip-content">
                        {{ t('automations-form-triggers_config-new_order-checkbox_tooltip') }}
                    </span>
                </span>
            </label>

            <div v-show="customFieldsFilter[field.id]['enabled']">
                <template v-if="field.type == 'checkbox'" >
                    <div class="options ml-3 mt-2 mb-1">
                        <div
                            class="field"
                            v-for="(option, index) in getActiveOptions(field)"
                            :key="index"
                        >
                        <label :for="`checkbox-${field.id}-${index}`">
                            <input
                                type="checkbox"
                                :value="option"
                                :id="`checkbox-${field.id}-${index}`"
                                v-model="customFieldsFilter[field.id].selected"
                                />
                            {{ option.text }}
                        </label>

                       
                        </div>
                    </div>
                </template>

                <template v-else >
                    <input
                        type="text"
                        class="form-control"
                        v-model="customFieldsFilter[field.id]['valueEqual']"
                        :placeholder="t('automations-form-triggers_config-new_order-placeholder_equal')"
                    />
                </template>
            </div>
            </template>
        </div>
    </div>
</template>
<style lang="less">
.filter-value {
    .row.inputs {
        margin-top: 10px;
    }
    input {
        margin-top: 4px;
    }
}
</style>
<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        let filterType =
            this.value.length > 0 && this.value[0].filterType
                ? this.value[0].filterType
                : "all";
        let filter =
            this.value.length > 0 && this.value[0].filter
                ? parseInt(this.value[0].filter)
                : null;
        let minValue =
            this.value.length > 0 && this.value[0].minValue
                ? this.float(this.value[0].minValue).toFixed(2)
                : null;
        let maxValue =
            this.value.length > 0 && this.value[0].maxValue
                ? this.float(this.value[0].maxValue).toFixed(2)
                : null;
        let filterValue =
            this.value.length > 0 && this.value[0].filterValue
                ? this.value[0].filterValue
                : false;
        return {
            filterType: filterType,
            filter: filter,
            filterValue: filterValue,
            minValue: minValue,
            maxValue: maxValue,
            customFieldsFilter: {},
            fields: []
           
        };
    },
    computed: {
        fieldsThatCanFilter() {
            return this.fields.filter(this.canFilterByField);
        },
        errors() {
            let errors = {};

            if (!this.filterType) {
                errors["filterType"] = "empty";
            }

            const numberFilterTypes = ["every", "exact", "greater", "lower"];
            if (
                numberFilterTypes.includes(this.filterType) &&
                !parseInt(this.filter)
            ) {
                errors["filter"] = "invalid";
            }

            let max = this.float(this.maxValue);
            let min = this.float(this.minValue);
            if (this.filterValue && max <= 0) {
                errors["filterValue"] = "invalid-max";
                errors["maxValue"] = "invalid";
            }
            if (this.filterValue && min >= max && min > 0) {
                errors["filterValue"] = "min-greater-than-max";
                errors["minValue"] = "greater-than-max";
            }
            return errors;
        },
        floatMax() {
            return this.float(this.maxValue);
        },
    },
    mounted: function () {
        this.loadFields();
        window.setTimeout(() => {
            this.changed();
        }, 100);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
       
        getActiveOptions(field) {
            if (!field.options || !Array.isArray(field.options)) return [];
            return field.options.filter(
                (opt) => !opt.removed && opt.active
            );
        },
        canFilterByField(field) {
            return (
                parseInt(field.show_on_reports) === 1 &&
                ["text", "checkbox"].includes(field.type)
            );
        },
        getCustomFieldEmptyFilter() {
            return {
                enabled: false,
                valueEqual: "",
                selected: [],  
            };
        },
        loadFields() {
            let options = keviApi.getOptions("/order-fields", "GET");
            this.$http(options).then((response) => {
                response.body.forEach((field) => {
                    if (this.canFilterByField(field)) {
                        if (this.customFieldsFilter[field.id] === undefined) {
                            this.$set(
                                this.customFieldsFilter,
                                field.id,
                                this.getCustomFieldEmptyFilter(),
                            );
                        }
                    }
                });
                this.fields = response.body;
            });
        },
        float(number) {
            let result = 0.0;
            if (number === null) {
                result = parseFloat(0);
            }
            if (typeof number === "number") {
                result = parseFloat(number);
            }
            if (typeof number === "string") {
                result = parseFloat(
                    number
                        .replace(".", "")
                        .replace(",", ".")
                        .replace(/[^0-9.]/gm, ""),
                );
            }
            return result;
        },
        isFieldValid(field) {
            return !Object.keys(this.errors).includes(field);
        },
        isValid: function () {
            return Object.keys(this.errors).length === 0;
        },
        changed: function () {
            this.$emit("input", [
                {
                    filter: this.filter,
                    filterType: this.filterType,
                    filterValue: this.filterValue,
                    minValue: this.float(this.minValue),
                    maxValue: this.float(this.maxValue),
                    customFieldsFilter: this.customFieldsFilter,
                },
            ]);
        },
    },
    watch: {
        filterType: function () {
            this.changed();
        },
        filter: function () {
            this.changed();
        },
        filterValue: function () {
            this.changed();
        },
        minValue: function () {
            this.changed();
        },
        maxValue: function () {
            this.changed();
        },
        customFieldsFilter: {
            handler: function () {
                this.changed();
            },
            deep: true,
        },
        value: function () {
            let filterType =
                this.value.length > 0 && this.value[0].filterType
                    ? this.value[0].filterType
                    : "all";
            let filter =
                this.value.length > 0 && this.value[0].filter
                    ? parseInt(this.value[0].filter)
                    : null;
            if (filter !== this.filter) {
                this.filter = filter;
            }
            if (filterType !== this.filterType) {
                this.filterType = filterType;
            }

            if (
                this.value[0] &&
                this.value[0].customFieldsFilter !== undefined &&
                JSON.stringify(this.value[0].customFieldsFilter) !==
                    JSON.stringify(this.customFieldsFilter)
            ) {
                this.customFieldsFilter = this.value[0].customFieldsFilter;
            }

            let minValue =
                this.value.length > 0 && this.value[0].minValue
                    ? this.value[0].minValue
                    : null;
            if (this.float(minValue) !== this.float(this.minValue)) {
                this.minValue = this.float(minValue).toFixed(2);
            }

            let maxValue =
                this.value.length > 0 && this.value[0].maxValue
                    ? this.value[0].maxValue
                    : null;
            if (this.float(maxValue) !== this.float(this.maxValue)) {
                this.maxValue = this.float(maxValue).toFixed(2);
            }

            let filterValue =
                this.value.length > 0 && this.value[0].filterValue
                    ? this.value[0].filterValue
                    : false;

            if (!!this.filterValue !== !!filterValue) {
                this.filterValue = filterValue;
            }
        },
    },
};
</script>
